import { components as c } from "@/components";
import { useSubmitTemplate } from "@/features/templates/hooks/useSubmitTemplate";
import { useTemplateNavigationStore } from "@/features/templates/hooks/useTemplateNavigationStore";
import { useTemplateStore } from "@/features/templates/stores/useTemplateStore";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { toast } from "sonner";

const NamePage = () => {
	const { templateId } = Route.useParams();
	const { handleSubmit, isSubmitting } = useSubmitTemplate(templateId);
	const { name, description, setName, setDescription } = useTemplateStore();
	const { markStepComplete, setCurrentStep } = useTemplateNavigationStore();
	const navigate = useNavigate();

	// Set this page as the current step
	useEffect(() => {
		setCurrentStep("name"); // Name is the last step (index 3)
	}, [setCurrentStep]);

	const form = useForm({
		defaultValues: {
			name,
			description,
		},
	});

	const onSubmit = async (data: { name: string; description: string }) => {
		try {
			setName(data.name);
			setDescription(data.description);
			markStepComplete("name");
			handleSubmit();
		} catch (error) {
			toast.error("Failed to create new diary");
			console.error("Form submission error:", error);
		}
	};

	return (
		<>
			<c.ui.Form {...form}>
				<form
					onSubmit={form.handleSubmit(onSubmit)}
					className="space-y-4 w-full"
				>
					<c.fc.Input
						description="This name will be used for all diaries which use this template"
						name="name"
						label="Name"
						placeholder="Enter diary name"
					/>

					<c.fc.Textarea
						name="description"
						description="This description will be used for all diaries which use this template"
						label="Description"
						placeholder="Enter diary description"
					/>

					<div className="flex justify-between gap-4 mt-8">
						<c.ui.Button
							type="button"
							variant="outline"
							onClick={() =>
								navigate({
									to: "/new/diary/$templateId/contact",
									params: { templateId },
								})}
						>
							Previous
						</c.ui.Button>

						<c.ui.Button type="submit" disabled={isSubmitting}>
							Submit
						</c.ui.Button>
					</div>
				</form>
			</c.ui.Form>
		</>
	);
};

export const Route = createFileRoute("/_app/new/diary/$templateId/name")({
	component: NamePage,
});
